import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import store from '../state/store';
import { getAffId } from '../utils/getAffId';
import { postLogin } from '../state/query/login';
import { AUTH_TYPES, ERROR_TYPES, LOGIN_ERROR_TYPE } from '../utils/authFlow/constants';
import ENVIRONMENT_VARIABLES from '../utils/environmentVariables';
import { setAvailableServiceStatus } from '../state/actions/availableServices';
import { clearGoogleToken, setGoogleToken } from '../state/actions/auth';
/**
 * Social login helper methods
 * Used in Start, TrackingURL(landing page) and LinkAccount
 */

export default {
  /**
   *
   * GOOGLE
   *
   */
  getGoogleId: function () {
    var _getGoogleId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
      var parts, encodedPayload, decodedPayload, payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // split token into header, payload, and signature
              parts = token.split('.');
              encodedPayload = parts[1]; // decode the payload from base64 and parse it as JSON

              if (!encodedPayload) {
                _context.next = 6;
                break;
              }

              decodedPayload = Buffer.from(encodedPayload, 'base64').toString('utf-8');
              payload = JSON.parse(decodedPayload);
              return _context.abrupt("return", payload.sub);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getGoogleId(_x) {
      return _getGoogleId.apply(this, arguments);
    }

    return getGoogleId;
  }(),

  /**
   * @summary loads the google sign-in script
   */
  loadGsi: function () {
    var _loadGsi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _document$querySelect, script;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!window.isGsiLoaded) {
                script = document.createElement('script');
                script.src = 'https://accounts.google.com/gsi/client';
                script.onload = this.initializeGsi;
                script.async = true;
                script.id = 'google-client-script';
                (_document$querySelect = document.querySelector('body')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.appendChild(script);
                window.isGsiLoaded = true;
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function loadGsi() {
      return _loadGsi.apply(this, arguments);
    }

    return loadGsi;
  }(),

  /**
   * @summary initializes gsi sdk and sets googleAuth
   * as an available service
   */
  initializeGsi: function initializeGsi() {
    if (!window.google || !window.isGsiLoaded) return;
    window.google.accounts.id.initialize({
      client_id: ENVIRONMENT_VARIABLES.GOOGLE_CLIENT_ID,
      callback: function callback(response) {
        return store.dispatch(setGoogleToken(response.credential));
      }
    });
    store.dispatch(setAvailableServiceStatus({
      googleAuth: true
    }));
  },
  googleLoginHandler: function () {
    var _googleLoginHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
      var setCanceledState, setErrorState, setSuccessState, googleToken, aff_id, googleId, response, _error$data, socialErrorType;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setCanceledState = _ref.setCanceledState, setErrorState = _ref.setErrorState, setSuccessState = _ref.setSuccessState;
              _context3.prev = 1;
              googleToken = store.getState().token.google_token;
              _context3.next = 5;
              return getAffId();

            case 5:
              aff_id = _context3.sent;
              googleId = this.getGoogleId(googleToken);
              _context3.next = 9;
              return store.dispatch(postLogin.initiate(_objectSpread({
                id_token: googleToken,
                google_id: googleId,
                login_type: AUTH_TYPES.GOOGLE
              }, aff_id && {
                aff_id: aff_id
              }))).unwrap();

            case 9:
              response = _context3.sent;

              if (response.success) {
                _context3.next = 12;
                break;
              }

              throw response;

            case 12:
              setSuccessState();
              store.dispatch(clearGoogleToken());
              _context3.next = 21;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](1);

              this._handleLoginError(_context3.t0, setCanceledState, setErrorState, LOGIN_ERROR_TYPE.GOOGLE);

              socialErrorType = 'google';
              setCanceledState({
                statusMessage: ((_error$data = _context3.t0.data) === null || _error$data === void 0 ? void 0 : _error$data.message) || _context3.t0.message,
                socialErrorType: socialErrorType
              });

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[1, 16]]);
    }));

    function googleLoginHandler(_x2) {
      return _googleLoginHandler.apply(this, arguments);
    }

    return googleLoginHandler;
  }(),

  /**
   *
   * FACEBOOK
   *
   */
  facebookLoginHandler: function () {
    var _facebookLoginHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref2) {
      var _this = this;

      var FB, CopySelector, permAccepted, setErrorState, setSuccessState, setCanceledState, fbLoginAuthType;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              FB = _ref2.FB, CopySelector = _ref2.CopySelector, permAccepted = _ref2.emailPermissionAccepted, setErrorState = _ref2.setErrorState, setSuccessState = _ref2.setSuccessState, setCanceledState = _ref2.setCanceledState;
              fbLoginAuthType = permAccepted === false ? {
                auth_type: 'rerequest'
              } : {};
              FB.login(
              /*#__PURE__*/

              /**
               * @param {Object} response
               * @param {String} response.status
               * @param {Object} response.authResponse
               * @param {String} response.authResponse.accessToken
               * @param {String} response.authResponse.userID
               */
              function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response) {
                  var emailPermissionAccepted, aff_id, request, statusMessage;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          emailPermissionAccepted = !!response.authResponse && !!response.authResponse.grantedScopes && response.authResponse.grantedScopes.includes('email');

                          if (!(response.status === 'connected' && emailPermissionAccepted)) {
                            _context4.next = 19;
                            break;
                          }

                          setSuccessState();
                          _context4.prev = 3;
                          _context4.next = 6;
                          return getAffId();

                        case 6:
                          aff_id = _context4.sent;
                          _context4.next = 9;
                          return store.dispatch(postLogin.initiate(_objectSpread({
                            token: response.authResponse.accessToken,
                            userID: response.authResponse.userID,
                            login_type: AUTH_TYPES.FACEBOOK
                          }, aff_id && {
                            aff_id: aff_id
                          }))).unwrap();

                        case 9:
                          request = _context4.sent;

                          if (request.success) {
                            _context4.next = 12;
                            break;
                          }

                          throw request;

                        case 12:
                          _context4.next = 17;
                          break;

                        case 14:
                          _context4.prev = 14;
                          _context4.t0 = _context4["catch"](3);

                          _this._handleLoginError(_context4.t0, setCanceledState, setErrorState, LOGIN_ERROR_TYPE.FACEBOOK);

                        case 17:
                          _context4.next = 22;
                          break;

                        case 19:
                          statusMessage = CopySelector.getCopy(CopySelector.COPY_TYPES.FACEBOOK_LOGIN_ERROR);

                          if (response.status === 'connected' && !emailPermissionAccepted) {
                            statusMessage = CopySelector.getCopy(CopySelector.COPY_TYPES.FACEBOOK_ACCEPT_PERMISSION);
                          }

                          setCanceledState({
                            statusMessage: statusMessage,
                            emailPermissionAccepted: emailPermissionAccepted,
                            socialErrorType: 'facebook'
                          });

                        case 22:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[3, 14]]);
                }));

                return function (_x4) {
                  return _ref3.apply(this, arguments);
                };
              }(), _objectSpread({
                scope: 'email',
                return_scopes: true
              }, fbLoginAuthType));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function facebookLoginHandler(_x3) {
      return _facebookLoginHandler.apply(this, arguments);
    }

    return facebookLoginHandler;
  }(),
  facebookLoginHandlerForLinkAccount: function facebookLoginHandlerForLinkAccount(FB, CopySelector) {
    return new Promise(function (resolve) {
      FB.login( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(response) {
          var emailPermissionAccepted, statusMessage;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  emailPermissionAccepted = !!response.authResponse && !!response.authResponse.grantedScopes && response.authResponse.grantedScopes.includes('email');

                  if (response.status === 'connected' && emailPermissionAccepted) {
                    resolve({
                      success: true,
                      facebookUser: response.authResponse
                    });
                  } else {
                    statusMessage = CopySelector.getCopy(CopySelector.COPY_TYPES.FACEBOOK_LOGIN_ERROR);

                    if (response.status === 'connected' && !emailPermissionAccepted) {
                      statusMessage = CopySelector.getCopy(CopySelector.COPY_TYPES.FACEBOOK_ACCEPT_PERMISSION);
                    }

                    resolve({
                      success: false,
                      error: statusMessage
                    });
                  }

                case 2:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x5) {
          return _ref4.apply(this, arguments);
        };
      }(), {
        scope: 'email',
        return_scopes: true,
        auth_type: 'rerequest'
      });
    });
  },

  /**
   *
   * COMMON
   *
   */
  _handleLoginError: function _handleLoginError(error, setCanceledState, setErrorState, loginErrorType) {
    var _error$data2, _error$data3;

    var errorCode = ((_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.error_code) || error.error_code;
    var message = ((_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : _error$data3.message) || error.message;
    setCanceledState({
      statusMessage: message,
      socialErrorType: errorCode === ERROR_TYPES.GEO_BLOCK ? LOGIN_ERROR_TYPE.COUNTRY_BLOCKED : loginErrorType
    });
  }
};